import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export const Button = ({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  className = '',
  ...props
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center font-bebas tracking-wider uppercase transition-all duration-300 rounded-sm';
  const variants = {
    primary: 'bg-gold-500 text-navy-950 hover:bg-gold-400 hover:shadow-[0_0_20px_rgba(212,175,55,0.4)] active:scale-95',
    outline: 'border-2 border-gold-500 text-gold-500 hover:bg-gold-500/10 active:scale-95',
    ghost: 'text-gold-500 hover:bg-navy-800 active:scale-95'
  };
  const sizes = {
    sm: 'px-4 py-2 text-lg',
    md: 'px-8 py-3 text-xl',
    lg: 'px-10 py-5 text-2xl md:text-3xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <button className={classes} {...props} data-id="element-464">
      {children}
    </button>;
};